export default __webpack_public_path__ + "static/media/weezevent-logo.d9370e46.svg";